export default { sha: '5f66cea6f9bdc5a417cd33ed1ee391a06b36f5bd', buildNumber: 'undefined' }
